import { render, staticRenderFns } from "./UserSettingTabItem.vue?vue&type=template&id=71de4b38&scoped=true&"
import script from "./UserSettingTabItem.vue?vue&type=script&lang=js&"
export * from "./UserSettingTabItem.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingTabItem.vue?vue&type=style&index=0&id=71de4b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de4b38",
  null
  
)

component.options.__file = "UserSettingTabItem.vue"
export default component.exports